import { render, staticRenderFns } from "./Fidelity.vue?vue&type=template&id=68d4e2ec"
import script from "./Fidelity.vue?vue&type=script&lang=js"
export * from "./Fidelity.vue?vue&type=script&lang=js"
import style0 from "./Fidelity.vue?vue&type=style&index=0&id=68d4e2ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports